import { COLOR } from "../utils/theme";

const FX = { NOK: 10.6, SEK: 10.3, EUR: 0.92 };

export function addLocal(usd, cur) {
  const sym = cur === "EUR" ? "\u20AC" : "kr";
  return usd + " / " + usd.replace(/\$([\d,]+)/g, (_, n) =>
    `${sym}${Math.round(parseFloat(n.replace(/,/g, "")) * FX[cur]).toLocaleString()}`
  );
}

export const CC = {
  free: COLOR.diffBorder, low: COLOR.costLow, moderate: COLOR.costModerate,
  dining: COLOR.mauveLight, flight: COLOR.costFlight, accommodation: COLOR.costAccommodation,
};
export const CC_TEXT = {
  free: COLOR.savedGreen, low: COLOR.costLowText, moderate: COLOR.costModerateText,
  dining: COLOR.mauveDark, flight: COLOR.costFlightText, accommodation: COLOR.costAccommodationText,
};
export const CL = {
  free: "FREE", low: "BUDGET", moderate: "MID",
  dining: "DINING", flight: "FLIGHT", accommodation: "STAY",
};

export const CATEGORIES = {
  sightseeing:   { iconName: "culture",        label: "Sightseeing" },
  dining:        { iconName: "dining",         label: "Dining" },
  cafe:          { iconName: "cafe",            label: "Café" },
  accommodation: { iconName: "accommodation",  label: "Accommodation" },
  transport:     { iconName: "transport",       label: "Transport" },
  nature:        { iconName: "nature",           label: "Nature" },
  activity:      { iconName: "activity",         label: "Activity" },
  culture:       { iconName: "culture",         label: "Culture" },
  shopping:      { iconName: "shopping",         label: "Shopping" },
  nightlife:     { iconName: "nightlife",        label: "Nightlife" },
  wellness:      { iconName: "wellness",         label: "Wellness" },
  beach:         { iconName: "beach",            label: "Beach" },
  leisure:       { iconName: "leisure",           label: "Leisure" },
};

export const VALID_CATEGORIES = Object.keys(CATEGORIES);

export const CATEGORY_COLORS = {
  dining:    { bg: COLOR.altCardGradient, text: COLOR.mauve, label: 'Dining' },
  culture:   { bg: COLOR.catCultureBg, text: COLOR.catCultureText, label: 'Culture' },
  leisure:   { bg: COLOR.diffBg, text: COLOR.lockedGreen, label: 'Leisure' },
  transport: { bg: COLOR.catTransportBg, text: COLOR.inkMid, label: 'Transport' },
  accommodation: { bg: COLOR.catAccommodationBg, text: COLOR.catAccommodationText, label: 'Stay' },
  shopping:  { bg: COLOR.catShoppingBg, text: COLOR.catShoppingText, label: 'Shopping' },
  nature:    { bg: COLOR.catNatureBg, text: COLOR.catNatureText, label: 'Nature' },
};
// Canonical casing — all costRange writes and reads must use these exact strings
export const COST_RANGES = ["free", "$", "$$", "$$$", "$$$$"];

export const COST_RANGE_OPTIONS = [
  { value: "free", label: "Free" },
  { value: "$",    label: "$ Budget" },
  { value: "$$",   label: "$$ Moderate" },
  { value: "$$$",  label: "$$$ Pricey" },
  { value: "$$$$", label: "$$$$ Luxury" },
];

export const VALID_BOOKING_STATUSES = ["not_needed", "book_now", "book_far_ahead", "book_day_of", "booked"];

export const GLOBAL_CSS = `
  @keyframes shimmer { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
  @keyframes slideUp { from{transform:translateY(100%)} to{transform:translateY(0)} }
  @keyframes slideDown { from{transform:translateY(0)} to{transform:translateY(105%)} }
  @keyframes slideInRight { from{transform:translateX(100%)} to{transform:translateX(0)} }
  @keyframes slideOutRight { from{transform:translateX(0)} to{transform:translateX(105%)} }
  @keyframes fadeIn { from{opacity:0} to{opacity:1} }
`;
